import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { auth } from '../firebase';
import { axiosWithAuth } from '../services/api';
import { useLoading } from '../context/loadingContext';

const ProcessandoPagamento = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { setLoading } = useLoading();
  const [mensagem, setMensagem] = useState("Aguarde enquanto confirmamos com o banco...");
  const [tentativa, setTentativa] = useState(0);

  useEffect(() => {
    const sleep = (ms) => new Promise(r => setTimeout(r, ms));

    const finalizarPagamento = async () => {
      setLoading(true);

      const paymentId = searchParams.get("PaymentId");
      if (!paymentId) {
        navigate("/revisao?erro=autenticacao");
        setLoading(false);
        return;
      }

      await auth.currentUser.reload();
      await auth.currentUser.getIdToken(true);
      const api = await axiosWithAuth();

      if (!api) {
        return;
      }

      const pollingInterval = 4000; // + tempo entre checagens
      const maxTentativas = 30; // ~2min
      let tentativas = 0;
      let finalized = false;

      const payloadBase = {
        paymentToken: paymentId,
        authentication: {
          Cavv: searchParams.get("Cavv"),
          Xid: searchParams.get("Xid"),
          Eci: searchParams.get("Eci"),
          ReferenceId: searchParams.get("ReferenceId"),
          Version: searchParams.get("Version")
        },
        payer: JSON.parse(localStorage.getItem("payer") || "{}"),
        installments: Number(localStorage.getItem("installments")) || 1,
        celular: localStorage.getItem("celular"),
        cidade: localStorage.getItem("cidade"),
        estado: localStorage.getItem("estado"),
        bairro: localStorage.getItem("bairro"),
        rua: localStorage.getItem("rua"),
        numero: localStorage.getItem("numero"),
        nomeCompleto: localStorage.getItem("nomeCompleto"),
        cpf: localStorage.getItem("cpf"),
        email: localStorage.getItem("email"),
        cartaData: localStorage.getItem("cartaData"),
        dibParaCalc: localStorage.getItem("dibParaCalc"),
        temPrpps: localStorage.getItem("temPrpps"),
        cep: localStorage.getItem("cep")
      };


      const limparLocalStorage = () => {
        [
          "paymentToken", "authentication", "payer", "installments", "uid", "celular",
          "cidade", "estado", "bairro", "rua", "numero", "nomeCompleto", "cpf", "email",
          "cartaData", "dibParaCalc", "temPrpps", "cep"
        ].forEach(k => localStorage.removeItem(k));
      };

      try {
        while (tentativas < maxTentativas && !finalized) {
          setTentativa(tentativas + 1);

          let statusRes;
          try {

            statusRes = await api.get(`/cielo/status/${paymentId}`);

          } catch (err) {
            console.warn(`Falha ao consultar status (tentativa ${tentativas + 1})`, err.message);
            await sleep(pollingInterval);
            tentativas++;
            continue;
          }

          const paymentStatus = statusRes.data?.Payment?.Status;

          switch (paymentStatus) {
            case 0: // NotFinished
            case 12: // Pending
            case 13: // Aborted
            case 20: // Scheduled
              setMensagem(`Aguardando confirmação bancária... (tentativa ${tentativas + 1})`);
              await sleep(pollingInterval);
              tentativas++;
              break;

            case 1: // Authorized
              setMensagem("Pagamento autorizado, aguardando captura...");
              await sleep(pollingInterval);
              tentativas++;
              break;

            case 2: // Confirmed
              setMensagem("Pagamento confirmado! Finalizando...");
              try {
                payloadBase.status = paymentStatus;

                const resp = await api.post('/card_payment', payloadBase, { timeout: 15000 });


                if (resp.status === 200) {
                  finalized = true;
                  limparLocalStorage();
                  navigate("/obrigado");
                } else {
                  throw new Error("Resposta inesperada do servidor.");
                }
              } catch (err) {
                console.error("Erro ao confirmar pagamento:", err.message);
                // Tenta mais uma vez no próximo loop, mas evita flood
                await sleep(pollingInterval);
                tentativas++;
              }
              break;

            case 3: // Denied
            case 10: // Voided
            case 11: // Refunded
              setMensagem("Pagamento recusado ou cancelado.");
              limparLocalStorage();
              navigate("/revisao?erro=pagamento");
              finalized = true;
              break;

            default:
              setMensagem("Status desconhecido, aguardando...");
              await sleep(pollingInterval);
              tentativas++;
          }
        }

        if (!finalized) {
          setMensagem("Tempo limite excedido. Tente novamente mais tarde.");
          navigate("/revisao?erro=pagamento");
        }

      } catch (err) {
        console.error("Erro geral ao processar pagamento:", err);
        setMensagem("Erro interno ao processar pagamento.");
        navigate("/revisao?erro=autenticacao");
      } finally {
        limparLocalStorage();
        setLoading(false);
      }
    };

    finalizarPagamento();
  }, []);

  return (
    <div className="obrigado-page">
      <h1>Processando pagamento...</h1>
      <p className='top-margin'>{mensagem}</p>
      {tentativa > 0 && <p>Verificando status... tentativa {tentativa}</p>}
    </div>
  );
};

export default ProcessandoPagamento;
